import React from 'react';
import SpotlightOverlay from './SpotlightOverlay';
import SpotlightTooltip from './SpotlightTooltip';

/**
 * Main Spotlight component that renders the feature announcement spotlight.
 * Add this component once in your app (typically in App.js after the Header).
 *
 * The spotlight system automatically shows announcements defined in
 * /src/config/announcements.js to users who haven't seen them yet.
 *
 * Usage:
 *   import Spotlight from './components/Spotlight';
 *   // In your app:
 *   <Spotlight />
 */
const Spotlight = () => {
  return (
    <>
      <SpotlightOverlay />
      <SpotlightTooltip />
    </>
  );
};

export default Spotlight;
